/**
 * GA4: count taps on phone (tel:) and text (sms:) links anywhere on the site.
 *
 * Sends the same `phone_call_click` event the lead hubs send, so the
 * receptionist dashboard and the weekly report count phone taps the same way
 * on every site. One delegated listener covers links rendered later by React.
 */
export function installCallClickTracking(): void {
  if (typeof window === 'undefined' || window.__callTapTracking) return;
  window.__callTapTracking = true;
  document.addEventListener(
    'click',
    (e) => {
      try {
        const target = e.target as Element | null;
        const a = target?.closest ? target.closest('a[href]') : null;
        if (!a) return;
        const href = (a.getAttribute('href') || '').trim();
        const scheme = href.slice(0, 4).toLowerCase();
        if ((scheme !== 'tel:' && scheme !== 'sms:') || typeof window.gtag !== 'function') return;
        window.gtag('event', 'phone_call_click', {
          link_type: scheme === 'tel:' ? 'tel' : 'sms',
          phone_number: href.slice(4).split('?')[0].replace(/[^0-9]/g, ''),
          page_path: location.pathname,
          transport_type: 'beacon',
        });
      } catch {
        // never let analytics break a click
      }
    },
    true,
  );
}
